import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=88abe8e2"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=88abe8e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports